
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartBoundariesLimitsProposal as ObiChartBoundariesLimitsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-boundaries-limits-proposal.js';
 
 
 

 
 export const ObiChartBoundariesLimitsProposal = createComponent({
   react: React,
   tagName: 'obi-chart-boundaries-limits-proposal',
   elementClass: ObiChartBoundariesLimitsProposalElement,
   events: {
     
   }
  });
 
 